import { useRouter } from 'next/router';

import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { useMultiEditMutation } from '../../../hooks/useMultiEditMutation';
import PropertyDescriptionStrength from '../../PropertyDescriptionStrength';

const inputName = 'roommateDetailsDescription';

const RoommateDescriptionFormField = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const initialValue = listingDetails?.roomForRent?.currentRoommatesDetails?.roommateDetailsDescription ?? '';

  const updateMutation = useMultiEditMutation();

  const field = useFieldSave({
    fieldName: inputName,
    initialValue,
    mutation: updateMutation,
    buildMutationVariables: (value) => ({
      postData: {
        property: {
          listingAlias,
          roomForRent: {
            roommateDetailsDescription: value,
          },
        },
      },
    }),
  });

  return (
    <FormField
      data-testid="RoommateDescriptionFormField"
      label={<Label>Roommates description</Label>}
      control={
        <Textarea
          name={inputName}
          value={field.value}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => field.onChange(e.target.value)}
          onBlur={field.onBlur}
          rows={10}
        />
      }
      error={!!field.error}
      description={
        field.error ? <FormHelp>{field.error}</FormHelp> : <PropertyDescriptionStrength description={field.value} />
      }
    />
  );
};

export default RoommateDescriptionFormField;
